<h2 mat-dialog-title class="dialog-title">Multi-factor Authentication</h2>
<mat-dialog-content>
  <div class="container">
    <div class="tab-items">
      @for (tab of tabItems; track tab) {
        <div class="tab" (click)="activeTab = tab.value">
          <button class="tab-button">{{ tab.buttonLabel }}</button>
          <span class="tab-label" [ngClass]="{ 'active-tab': activeTab === tab.value }">{{ tab.label }}</span>
        </div>
      }
    </div>
    <div class="tab-content">
      @switch (activeTab) {
        @case ("setup") {
          <app-mfa-setup (onContinue)="activeTab = 'verify'" />
        }
        @case ("verify") {
          <app-mfa-verification type="setup" />
        }
      }
    </div>
  </div>
</mat-dialog-content>
